/**
 * useThinkingMessage Hook
 *
 * Cycles through thinking action phrases (e.g., "seeking wisdom...")
 * when active. Messages rotate every 3 seconds.
 */

import { useState, useEffect } from 'react';

const THINKING_MESSAGES = [
  // Spiritual messages
  'seeking wisdom...',
  'praying...',
  'reflecting...',
  'meditating...',
  'discerning...',
  'contemplating...',
  // Professional messages
  'analyzing...',
  'processing...',
  'thinking...',
  'considering...',
  'pondering...',
  'evaluating...',
  // Whimsical messages (family-friendly, faith-themed)
  'razzle dazzling...',
  'splitting hairs...',
  'counting sheep...',
  'polishing the crown...',
  'consulting the scrolls...',
];

export function useThinkingMessage(isThinking: boolean): string | undefined {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (!isThinking) {
      setMessageIndex(0);
      return;
    }

    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % THINKING_MESSAGES.length);
    }, 3000);

    // eslint-disable-next-line consistent-return
    return () => clearInterval(interval);
  }, [isThinking]);

  return isThinking ? THINKING_MESSAGES[messageIndex] : undefined;
}

export default useThinkingMessage;
